import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectPaymentState = (state: RootState) => state.paymentTypes;

const selectGetPaymentTypes = createSelector(
  selectPaymentState,
  (state) => state.paymentTypes
);

export const selectors = {
  selectGetPaymentTypes
};
